import React from "react";
import {Svg, Path} from "react-primitives-svg";
import PropTypes from "prop-types";
import {svgSize} from "../helpers/svg";

export default function Icon({fill, height, width, ...rest}) {
  return (
    <Svg
      {...rest}
      {...svgSize(height, width)}
      viewBox="0 0 122.88 122.88"
      preserveAspectRatio="xMidYMid meet">
      <Path
        fill={"#d92d27"}
        d="M118.22,38a61.53,61.53,0,1,1-13.34-20,61.29,61.29,0,0,1,13.34,20ZM61.44,12.08A49.36,49.36,0,1,1,12.08,61.44,49.36,49.36,0,0,1,61.44,12.08Z"
        className="cls-1"
      />
      <Path
        fill={"#fff"}
        fillRule="evenodd"
        d="M61.44,12.08A49.36,49.36,0,1,1,12.08,61.44,49.36,49.36,0,0,1,61.44,12.08Z"
        className="cls-2"
      />
      <Path
        fill={fill}
        d="M47.17,80.92q-4.12,0-8-.36a66.91,66.91,0,0,1-7.16-1v-8H43.25a18,18,0,0,0,3.12-.2,2.66,2.66,0,0,0,1.52-.67,1.85,1.85,0,0,0,.41-1.29v-1a2.27,2.27,0,0,0-.46-1.49A2.8,2.8,0,0,0,46.5,66a8.36,8.36,0,0,0-2.16-.34l-9.17-.41V57.53l8.7-.56a9.2,9.2,0,0,0,3-.62,1.68,1.68,0,0,0,1-1.65v-.47a2.26,2.26,0,0,0-1-2.11,8.16,8.16,0,0,0-3.81-.62H32.54v-8q3.35-.57,7.06-1.06A48.15,48.15,0,0,1,47.12,42a14.78,14.78,0,0,1,5.69,1.11,7.85,7.85,0,0,1,3.68,3.2,10.34,10.34,0,0,1,1.29,5.43v2.58a11.21,11.21,0,0,1-.23,2.39,6.53,6.53,0,0,1-.75,2,5.44,5.44,0,0,1-1.34,1.57,6.64,6.64,0,0,1-2,1.09,5.36,5.36,0,0,1,2.14,1.16,6.91,6.91,0,0,1,1.5,1.88,9.64,9.64,0,0,1,.9,2.44,13.52,13.52,0,0,1,.31,2.91v1.5a8.82,8.82,0,0,1-3,7.16q-3,2.47-8.17,2.47Zm25.24,0a12.47,12.47,0,0,1-5.84-1.23,7.78,7.78,0,0,1-3.48-3.58A12.7,12.7,0,0,1,62,70.52V53a13.25,13.25,0,0,1,1.21-6,8.22,8.22,0,0,1,3.58-3.68A12,12,0,0,1,72.47,42h8.34a11.06,11.06,0,0,1,5.49,1.27A8.15,8.15,0,0,1,89.7,47a13.83,13.83,0,0,1,1.16,6V70.52a10.73,10.73,0,0,1-2.6,7.62q-2.61,2.77-7.5,2.78Zm2.48-9H78a3,3,0,0,0,2.14-.7A3,3,0,0,0,80.86,69V54a3.07,3.07,0,0,0-.72-2.4A2.68,2.68,0,0,0,78.39,51H74.53a2.44,2.44,0,0,0-2,.72A3.46,3.46,0,0,0,72,54V68.92a3.15,3.15,0,0,0,.72,2.34,3.06,3.06,0,0,0,2.22.7Z"
      />
    </Svg>
  );
}

Icon.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Icon.displayName = "Icons.Speedlimit";
